<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px" fxFill>
    <ng-credit-card
        [name]="creditCardData.name"
        [number]="creditCardData.number"
        [cvc]="creditCardData.cvc"
        [expiry]="creditCardData.expiry"
        [focused]="focused"
    ></ng-credit-card>

    <form fxFill [formGroup]="creditCardForm" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
        <mat-form-field fxFill>
            <mat-label>{{ "ADD_CREDIT_CARD.NUMBER.LABEL" | translate }}</mat-label>
            <input
                type="text"
                matInput
                formControlName="cardNumber"
                [mask]="cardMask"
                class="cc-number"
                pattern="\d*"
                x-autocompletetype="cc-number"
                [(ngModel)]="creditCardData.number"
                (focus)="focused = 'number'"
            />
            <mat-error>{{ "ADD_CREDIT_CARD.NUMBER.ERROR" | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field fxFill>
            <mat-label>{{ "ADD_CREDIT_CARD.HOLDER.LABEL" | translate }}</mat-label>
            <input
                type="text"
                matInput
                formControlName="holder"
                x-autocompletetype="cc-name"
                [(ngModel)]="creditCardData.name"
                (focus)="focused = 'name'"
            />
            <mat-error>{{ "ADD_CREDIT_CARD.HOLDER.ERROR" | translate }}</mat-error>
        </mat-form-field>

        <!-- Adição do campo phone -->
        <mat-form-field fxFill *ngIf="requirePhone">
            <mat-label>{{ "ADD_CREDIT_CARD.PHONE.LABEL" | translate }}</mat-label>
            <input
                type="tel"
                matInput
                formControlName="phone"
                [mask]="'(00) 0000-00009'"
                pattern="\d{10,11}"
                x-autocompletetype="tel"
                [(ngModel)]="creditCardData.phone"
                (focus)="focused = 'phone'"
            />
            <mat-error>{{ "ADD_CREDIT_CARD.PHONE.ERROR" | translate }}</mat-error>
        </mat-form-field>

        <div fxFill fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
            <mat-form-field fxFlex>
                <mat-label>{{ "ADD_CREDIT_CARD.EXPIRY.LABEL" | translate }}</mat-label>
                <input
                    matInput
                    formControlName="expirationDate"
                    [(ngModel)]="creditCardData.expiry"
                    mask="00/00"
                    [placeholder]="'ADD_CREDIT_CARD.EXPIRY.PLACE_HOLDER' | translate"
                    pattern="\d*"
                    x-autocompletetype="cc-exp"
                    (focus)="focused = 'expiry'"
                />
                <mat-error>{{ "ADD_CREDIT_CARD.EXPIRY.ERROR" | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex>
                <mat-label>{{ "ADD_CREDIT_CARD.SECURITY_CODE.LABEL" | translate }}</mat-label>
                <input
                    type="text"
                    matInput
                    formControlName="securityCode"
                    [(ngModel)]="creditCardData.cvc"
                    mask="0009"
                    x-autocompletetype="cc-cvc"
                    (focus)="focused = 'cvc'"
                />
                <mat-error>{{ "ADD_CREDIT_CARD.SECURITY_CODE.ERROR" | translate }}</mat-error>
            </mat-form-field>
        </div>

        <div fxFill fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
            <mat-slide-toggle color="primary" formControlName="isDefault" [(ngModel)]="creditCardData.isDefault">
                {{ "ADD_CREDIT_CARD.IS_DEFAULT" | translate }}
            </mat-slide-toggle>
        </div>
    </form>
</div>
